import Block from './Block'

export default class Products extends Block {
  onEnterCompleted() {
    super.onEnterCompleted()

    this.init()
  }

  bindMethods() {
    super.bindMethods()
  }

  getElems() {
    super.getElems()

    this.$wrapper = this.el.querySelector('.b-products__wrapper')
    this.$container = this.el.querySelector('.b-products__container')
    this.$dots = this.el.querySelectorAll('.b-products__dot')
  }

  events() {
    super.events()

    for (let i = 0; i < this.$dots.length; i++) {
      this.$dots[i].addEventListener('click', this.move.bind(this, i))
    }
  }

  init() {
    if (this.current) this.$dots[this.current].classList.remove('active')
    this.$dots[0].classList.add('active')
    this.translate = this.$wrapper.getBoundingClientRect().width
    this.$container.style.transform = 'translateX(0px)'
    this.current = 0
  }

  move(i) {
    const translate = -this.translate * i

    this.$dots[this.current].classList.remove('active')
    this.$dots[i].classList.add('active')
    this.$container.style.transform = 'translateX(' + translate + 'px)'
    this.current = i
  }

  resize() {
    super.resize()

    this.init()
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Products.js